import * as React from "react";
import { useCallback } from "react";
import { QualifiedFeatureFragment, UserRoles } from "fe-common/graphql";
import { usePatient } from "../../../state/patientContext";
import { RoleRestrictor } from "fe-web-components/roles/RoleRestrictor";
import { InChatDemoReasoningIcon } from "./inChatDemoReasoningIcon";
import { ACTION, CATEGORY, evt } from "fe-common/analytics/analytics";
import { ClusterWithCr } from "../../../solverHooks/useConversationDD";

//region [[ Styles ]]
//endregion [[ Styles ]]

//region [[ Props ]]

export interface ShowDemoReasoningButtonProps {
  suggestion?: QualifiedFeatureFragment;
  // We need to be able to mark the suggestion aa a background finding since the graph has
  // a causality direction. meaning if this suggestion is a background finding
  // we would want to show a graph explaining how this background condition causes our
  // suspected disease. Otherwise - as usual - we would ask how this disease
  // causes this suspected symptom?
  isBackgroundSuggestion?: boolean;
  // Does the reasoning is for a dd cluster
  cluster?: ClusterWithCr;
  // Does this reasoning is for a triage advice?
  triage?: boolean;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

const SupportedReasoningRoles = [
  UserRoles.KahunBackofficeUsers,
  UserRoles.KahunPatientDemoUsers,
];

export const ShowInChatReasoningButton = ({
  suggestion,
  isBackgroundSuggestion,
  cluster,
  triage,
  ...props
}: ShowDemoReasoningButtonProps) => {
  const {
    updateSelectedSuggestion,
    updateSelectedDiseaseReasoning,
    setShowTriageReasoning,
  } = usePatient();

  const setSelectedSuggestion = useCallback(() => {
    evt({
      category: CATEGORY.PATIENT_CHAT,
      action: ACTION.PATIENT_Q_REASONING_CLICK,
      label: suggestion?.feature?.name,
    });
    if (suggestion) {
      updateSelectedSuggestion({
        qualifiedFeature: suggestion,
        isBackgroundSuggestion,
      });
      updateSelectedDiseaseReasoning(null);
      setShowTriageReasoning(false);
    } else if (cluster) {
      updateSelectedDiseaseReasoning({
        diseaseId: cluster.title.id,
        diseaseName: cluster.title.name,
      });
      updateSelectedSuggestion(null);
      setShowTriageReasoning(triage);
    } else if (triage) {
      setShowTriageReasoning(true);
      updateSelectedSuggestion(null);
      updateSelectedDiseaseReasoning(null);
    }
  }, [
    cluster,
    updateSelectedSuggestion,
    suggestion,
    isBackgroundSuggestion,
    updateSelectedDiseaseReasoning,
    triage,
    setShowTriageReasoning,
  ]);

  return (
    <RoleRestrictor roles={SupportedReasoningRoles}>
      <InChatDemoReasoningIcon onClick={setSelectedSuggestion} />
    </RoleRestrictor>
  );
};
